import { render, staticRenderFns } from "./EditProducer.vue?vue&type=template&id=3273cd0c&scoped=true"
import script from "./EditProducer.vue?vue&type=script&lang=js"
export * from "./EditProducer.vue?vue&type=script&lang=js"
import style0 from "./EditProducer.vue?vue&type=style&index=0&id=3273cd0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3273cd0c",
  null
  
)

export default component.exports